module.exports = __webpack_public_path__ + "static/desktop/img/diarybook-5-thumb.4eeba2bb.png";